import type { CompRef } from '@wix/document-services-types';
import { ComponentRef } from '@wix/editor-platform-sdk-types';
import { PrivateAPINamespace } from '../PrivateAPINamespace';

import { ImageComponent, TextComponent, UnknownComponent } from './sdks';

import { Addon, ApiConfig } from '../../limitPrivateAPI';

import type { EditorPointer } from '@wix/editor-document-logic-api';

export type IComponent = ImageComponent | TextComponent | UnknownComponent;

const TEXT_COMPONENT_TYPES = [
  'wysiwyg.viewer.components.WRichText',
  'wixui.CollapsibleText',
];

const IMAGE_COMPONENT_TYPES = [
  'wysiwyg.viewer.components.WPhoto',
  'wixui.ImageX',
];

function getComponentsFactory(compType: string) {
  if (TEXT_COMPONENT_TYPES.includes(compType)) {
    return TextComponent;
  } else if (IMAGE_COMPONENT_TYPES.includes(compType)) {
    return ImageComponent;
  }

  return null;
}

export class ComponentsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'components';

  @ApiConfig(Addon)
  public async getSelectedComponents(): Promise<ComponentRef[]> {
    return this.ps.hostAPI.editor.selection.getSelectedComponents();
  }

  @ApiConfig(Addon)
  public async getComponent(compRef: ComponentRef): Promise<IComponent> {
    const compType = this.ps.ds.components.getType(compRef);

    const Factory = getComponentsFactory(compType);

    if (!Factory) {
      return new UnknownComponent(compRef, compType);
    }

    return new Factory(compRef, this.ps);
  }

  public async getSingleSelectedEditorPointer(): Promise<EditorPointer<CompRef> | null> {
    try {
      return this.ps.hostAPI.editor.selection.getSingleSelectedOrThrow();
    } catch {
      return null;
    }
  }
}
